import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=09a2a8f2&scoped=true&"
import script from "./how-it-works.vue?vue&type=script&lang=js&"
export * from "./how-it-works.vue?vue&type=script&lang=js&"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=09a2a8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2a8f2",
  null
  
)

export default component.exports